import React from 'react';

import { elementScrollIntoViewPolyfill } from 'seamless-scroll-polyfill';

import { handleKeyDown } from '@pkg/utils';

import './EmojiSliderNav.scss';

interface Props {
    sections: string[];
    activeSection: number;
}

const EmojiSliderNav = ({ sections, activeSection }: Props) => {
    elementScrollIntoViewPolyfill();

    const scrollToCategory = (slug: string, e) => {
        e.preventDefault();
        const element = document.querySelector(`#${slug}`) as HTMLElement;
        const inline = window.matchMedia(`(max-width: 576px)`).matches ? 'start' : 'center';
        const options = { behavior: 'smooth', inline: inline } as ScrollIntoViewOptions;
        element.scrollIntoView(options);
    };

    return (
        <nav className="emoji-slider-nav">
            <ul className="emoji-slider-nav__list">
                {sections.map((section, i) => (
                    <li key={i} className="emoji-slider-nav__item">
                        <div
                            tabIndex={0}
                            className={`emoji-slider-nav__link ${activeSection === i + 1 ? '-active' : ''}`}
                            onClick={(e) => scrollToCategory('emoji-slider-section-' + i, e)}
                            onKeyDown={(e) =>
                                handleKeyDown(e, ['Enter', ' '], () => scrollToCategory('emoji-slider-section-' + i, e))
                            }
                            aria-label={section}
                        >
                            {section}
                        </div>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default EmojiSliderNav;
